// extracted by mini-css-extract-plugin
export var privacy_policy = "index-module--privacy_policy--r7O3H";
export var banner_container = "index-module--banner_container--BPuip";
export var text = "index-module--text--AKMVh";
export var title = "index-module--title--anacR";
export var message_container = "index-module--message_container--T9fgD";
export var intro = "index-module--intro--m-tiP";